import {LoadingController, AlertController, NavController, Platform} from 'ionic-angular';
import {BackendModule} from './../../../../modules/backend.module';
import {SessionService} from './../../../../services/session';
import {Component} from '@angular/core';
import {LocationsService} from '../../../../services/locations';
import {BeautyClassesService} from '../../../../services/beauty-classes';
import {BeautyPage} from '../../beauty/beauty';


@Component({
  selector: 'page-beauty-review',
  templateUrl: 'beauty-review.html'
})
export class BeautyReviewPage {
  lesson: any;
  image = [];
  tabsPage = BeautyPage;

  review = {
    grade: 0,
    comments: '',
    reservation_id: ''
  }

  public unregisterBackButtonAction: any;

  constructor(public sessionService: SessionService,
              public classesService: BeautyClassesService,
              public backendModule: BackendModule,
              public loadingCtrl: LoadingController,
              public alertCtrl: AlertController,
              public navCtrl: NavController,
              public platform: Platform,
              public locationsService: LocationsService) {
  }

  ngOnInit() {
    this.initReview()
  }

  ionViewDidLoad() {
    this.initializeBackButtonCustomHandler()
  }

  initializeBackButtonCustomHandler(): void {
    // Priority 101 will override back button handling (we set in app.component.ts) as it is bigger
    // then priority 100 configured in app.component.ts file */
    this.unregisterBackButtonAction = this.platform.registerBackButtonAction(
      function (event) {
      }, 101);
  }

  initReview() {
    this.lesson = this.sessionService.beautyReservations.toReview[0]
    this.image[0] = {image_url: this.lesson.image_url};
    this.testImage(this.image[0].image_url);
    this.review.reservation_id = this.lesson.schedule.reservation.id
  }

  testImage(url) {
    var tester = new Image();
    tester.src = url;
    tester.addEventListener('error', () => {
      this.image = [{image_url: './assets/img/god.jpg'}];
    });
  }

  reviewClass() {
    let loading = this.loadingCtrl.create();
    loading.present();

    this.backendModule.postAPI(
      'reviews',
      this.review
    ).subscribe(
      (s) => {
        loading.dismiss();
        this.sessionService.beautyReservations.toReview.shift();
        if (this.sessionService.beautyReservations.toReview.length >= 1) {
          this.review.grade = 0;
          this.review.comments = '';
          this.initReview();
        } else {
          // this.navCtrl.setRoot(this.tabsPage, {'dontLoad': true});
          this.navCtrl.popToRoot();
        }
      },
      err => {
        this.sessionService.reportError('reviewPage', 'reviewClass()', err);

        let alert = this.alertCtrl.create({
          title: 'Error',
          message: 'Error al calificar. Por favor inténtalo de nuevo.',
          buttons: [{text: 'Ok',}]
        });
        alert.present();
        loading.dismiss();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/beauty-review/beauty-review.ts